import { useChain } from './useChain';

export const useChainId = (): string => {
  const chain = useChain();
  return chain?.id ?? '';
};
